'use strict';

const { tns } = require('tiny-slider');
const { CLASSES } = require('friartux/utils/globals');
const createErrorNotification = require('friartux/components/errorNotification');
const createInfoNotification = require('friartux/components/infoNotification');
const urlHelper = require('friartux/utils/urlHelper');
const cookieHelper = require('friartux/components/cookieHelper');
var replicaSlider;
var replicaCookie = 'replica-consent';
var $lastTryOnTrigger = null;
var BACKGROUND_SELECTOR = 'header, main, footer, .notification-bar-header';
var lastOutfitSignature = null;

const SELECTORS = {
    body: 'body',
    tryOnBtn: '.js-aitryon',
    tryOnModal: '.js-aitryon-modal',
    tryOnModalClose: '.js-aitryon-modal-close',
    fileUploader: '.js-file-uploader',
    fileUploaderContainer: '.js-replica-uploader',
    csrfToken: '.js-replica-csrf',
    noSetupBtn: '.js-no-setup',
    quickSetupBtn: '.js-quick-setup',
    advanceSetupBtn: '.js-advance-setup',
    actionTab: '.js-action-tab',
    uploaderTab: '.js-uploader-tab',
    viewerTab: '.js-viewer-tab',
    viewerTabSlider: '.js-replica-slider',
    feedbackTab: '.js-feedback-tab',
    feedbackInput: '.js-feedback-input',
    backBtn: '.js-back-btn',
    generateBtnWrapper: '.js-generate-btn-wrapper',
    generateBtn: '.js-generate-btn',
    generateBtns: '.js-generate-btn, .js-regenerate-btn',
    uploadNewBtn: '.js-upload-new-btn',
    errorMessage: '.error-messaging',
    infoMessage: '.info-messaging',
    pageButtons: '.slider-thumbnail-control',
    customerImageContainer: '.js-customer-image',
    photoContainer: '.js-photo',
    zoomImage: '.js-viewer-tab .tns-item img',
    removeFileInput: '.fileinput-remove',
    feedbackBtn: '.js-feedback-btn',
    feedbackSubmit: '.js-submit-feedback',
    consentCheckBox: '.js-replica-consent',
    consentCheckBoxLabel: '.js-replica-consent-label',
    consentCheckBoxGroup: '.js-replica-consent-group',
    selectedProductCards: '.js-selected-products [data-prodid]'
};

function init() {
    $(SELECTORS.body).on('click', SELECTORS.tryOnBtn, handleTryOnButton);
    $(SELECTORS.body).on('click', SELECTORS.noSetupBtn, handleNoSetupBtn);
    $(SELECTORS.body).on('click', SELECTORS.quickSetupBtn, handleQuickSetupBtn);
    $(SELECTORS.body).on('click', SELECTORS.advanceSetupBtn, handleAdvanceSetupBtn);
    $(SELECTORS.body).on('click', SELECTORS.backBtn, handleBackBtn);
    $(SELECTORS.body).on('click', SELECTORS.generateBtns, handleGenerateBtn);
    $(SELECTORS.body).on('click', SELECTORS.uploadNewBtn, handleUploadNewBtn);

    initFileUploader();

    $(SELECTORS.body).on('click', SELECTORS.tryOnModalClose, handleTryOnModalCloseButton);
    $(SELECTORS.body).on('change', SELECTORS.consentCheckBox, handleConsentChange);
    initReplicaConsent();

    // try-on cookie counter
    $(SELECTORS.body).on('click', SELECTORS.noSetupBtn +", "+ SELECTORS.generateBtn, tryonCookieCounter);

    // #17 — label is the AT-exposed checkbox control. Space/Enter on the focused
    // label should toggle the hidden native input (delegated so it works even
    // before the modal renders).
    $(SELECTORS.body).on('keydown', SELECTORS.consentCheckBoxLabel, handleConsentCheckBoxLabel);

    initAccessibility();
}

// Keep aria-checked on the label in sync with the actual input state.
function syncConsentAriaChecked() {
    var isChecked = $(SELECTORS.consentCheckBox).is(':checked');
    $(SELECTORS.consentCheckBoxLabel).attr('aria-checked', isChecked ? 'true' : 'false');
}

const handleTryOnButton = (e) => {
    // #20 — remember the trigger so we can return focus on close
    $lastTryOnTrigger = $(e.currentTarget);

    $(SELECTORS.tryOnModal)
        .addClass(CLASSES.flex)
        .removeClass(CLASSES.hide)
        .attr('aria-hidden', 'false');

    // Hide the rest of the page from AT while modal is open
    $(BACKGROUND_SELECTOR).attr('aria-hidden', 'true');

    $(SELECTORS.body).css('overflow', 'hidden');

    // Move focus into the dialog so screen readers announce the heading
    var $heading = $(SELECTORS.tryOnModal).find('#aiTryOnHeading');
    if ($heading.length) {
        $heading.attr('tabindex', '-1').trigger('focus');
    }

    restartOnCartChange();
}

/**
 * Whether the currently open modal is the cart outfit flow (submits to
 * Replica-CreateOutfit) rather than the single-product PDP flow.
 */
function isOutfitContext() {
    var generateUrl = $(SELECTORS.fileUploaderContainer).data('generate-url');
    return !!generateUrl && String(generateUrl).indexOf('CreateOutfit') !== -1;
}

/**
 * Build a signature of the current "Your Look" (primary) items from their master
 * product ids, so it changes only when the set of styles changes.
 */
function getSelectedProductsSignature() {
    var prodIds = [];
    $(SELECTORS.selectedProductCards).each(function () {
        prodIds.push($(this).attr('data-prodid'));
    });
    return prodIds.sort().join('|');
}

/**
 * Remember the primary items that the just-generated outfit corresponds to.
 */
function captureOutfitSignature() {
    if (isOutfitContext()) {
        lastOutfitSignature = getSelectedProductsSignature();
    }
}

/**
 * On reopening the cart modal, if the primary items changed since the last
 * generation, reset to the action tab and trigger the quick-setup flow so the
 * customer regenerates for the updated cart.
 */
function restartOnCartChange() {
    if (!isOutfitContext() || lastOutfitSignature === null) {
        return;
    }

    if (getSelectedProductsSignature() === lastOutfitSignature) {
        return;
    }

    $(SELECTORS.quickSetupBtn).trigger('click');
}

const handleNoSetupBtn = () => {
    $(SELECTORS.actionTab)
        .addClass(CLASSES.hide);

    $(SELECTORS.viewerTab)
        .removeClass(CLASSES.hide);

    generateReplica();

    showBackButton();
}

const handleQuickSetupBtn = () => {

    if (!validateConsent()) {
        return;
    }

    $(SELECTORS.actionTab)
        .addClass(CLASSES.hide);

    $(SELECTORS.uploaderTab)
        .removeClass(CLASSES.hide);

    showBackButton();

    let customerHasImage = $(SELECTORS.fileUploaderContainer).data('customer-has-image');
    if (customerHasImage) {
        $(SELECTORS.generateBtnWrapper).removeClass(CLASSES.hide);
        $(SELECTORS.customerImageContainer).removeClass(CLASSES.hide);
        $(SELECTORS.fileUploaderContainer).addClass(CLASSES.hide);
    }
}

const handleAdvanceSetupBtn = () => {
    $(SELECTORS.actionTab)
        .addClass(CLASSES.hide);

    $(SELECTORS.uploaderTab)
        .removeClass(CLASSES.hide);
    showBackButton();
}

const handleBackBtn = () => {
    submitFeedback();

    $(SELECTORS.actionTab)
        .removeClass(CLASSES.hide);

    $(SELECTORS.uploaderTab)
        .addClass(CLASSES.hide);

    $(SELECTORS.viewerTab)
        .addClass(CLASSES.hide);

    $(SELECTORS.generateBtnWrapper)
        .addClass(CLASSES.hide);

    $(SELECTORS.backBtn)
        .addClass(CLASSES.hide);

    $(SELECTORS.feedbackTab)
        .addClass(CLASSES.hide);
}

const handleGenerateBtn = () => {
    let useUserImage = true;
    generateReplica(useUserImage);
}

const handleUploadNewBtn = () => {
    $(SELECTORS.customerImageContainer)
        .addClass(CLASSES.hide);

    $(SELECTORS.generateBtnWrapper)
        .addClass(CLASSES.hide);

    $(SELECTORS.fileUploaderContainer)
        .removeClass(CLASSES.hide);

    $(SELECTORS.removeFileInput).click();
}

const handleConsentChange = (e) => {
    let $this = $(e.target);
    if ($this.is(':checked')) {
        cookieHelper.setCookie(replicaCookie, 'true', 30);
        $(SELECTORS.quickSetupBtn).data('consent', true);
        $(SELECTORS.consentCheckBoxGroup).removeClass('is-invalid');
        $(SELECTORS.consentCheckBoxGroup)
            .find('.js-invalid-message')
            .addClass(CLASSES.hide);
    } else {
        cookieHelper.deleteCookie(replicaCookie);
        $(SELECTORS.quickSetupBtn).data('consent', false);
        $(SELECTORS.consentCheckBoxGroup)
            .find('.js-invalid-message')
            .addClass(CLASSES.hide);
    }
    syncConsentAriaChecked();
}

// Space or Enter on the focused label toggles the associated input.
// preventDefault on Space stops the page from scrolling.
const handleConsentCheckBoxLabel = (e) => {
    if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
        e.preventDefault();
        $(e.currentTarget).trigger('click');
    }
}

function initReplicaConsent() {
    let hasReplicaCookie = cookieHelper.getCookie(replicaCookie);
    $(SELECTORS.consentCheckBox).prop('checked', hasReplicaCookie);
    $(SELECTORS.quickSetupBtn).data('consent', hasReplicaCookie);
    syncConsentAriaChecked();
}

function validateConsent() {
    let consented = $(SELECTORS.quickSetupBtn).data('consent');

    if (consented) {
        $(SELECTORS.consentCheckBoxGroup).removeClass('is-invalid');
        $(SELECTORS.consentCheckBoxGroup)
            .find('.js-invalid-message')
            .addClass(CLASSES.hide);
    } else {
        $(SELECTORS.consentCheckBoxGroup).addClass('is-invalid');
        $(SELECTORS.consentCheckBoxGroup)
            .find('.js-invalid-message')
            .removeClass(CLASSES.hide);
    }

    return consented;
}

function generateReplica(useUserImage) {
    let $tryOnModal = $(SELECTORS.tryOnModal);
    let $uploader = $(SELECTORS.fileUploaderContainer);
    $tryOnModal.spinner().start();

    $.ajax({
        url: $uploader.data('generate-url'),
        type: 'POST',
        dataType: 'json',
        data: {
            'csrf_token': $(SELECTORS.csrfToken).val(),
            'pid': $uploader.data('pid'),
            'useUserImage': useUserImage
        },
        success: function (data) {
            if (data.debug) {
                createInfoNotification($(SELECTORS.errorMessage), data.debugData);
            }

            if (!data.success) {
                createErrorNotification($(SELECTORS.errorMessage), data.errorMessage);
                $tryOnModal.spinner().stop();
                return;
            }

            let generation = (data.replica.userGenerations || [])[0];
            if (generation && generation.status === 'pending') {
                pollReplicaImage(data.replica.replicaId);
                return;
            }

            createImageSlider(data, useUserImage);
            $(SELECTORS.generateBtnWrapper).addClass(CLASSES.hide);
            displayViewer();
            captureOutfitSignature();
            $tryOnModal.spinner().stop();
        },
        error: function (err) {
            createErrorNotification($(SELECTORS.errorMessage), err.responseJSON.errorMessage);
            if (err.responseJSON.redirectUrl) {
                window.location.href = err.responseJSON.redirectUrl;
            }
            $tryOnModal.spinner().stop();
        }
    });
}

function pollReplicaImage(replicaId) {
    let $tryOnModal = $(SELECTORS.tryOnModal);
    let statusUrl = urlHelper.appendToUrl($(SELECTORS.fileUploaderContainer).data('status-url'), { rid: replicaId });

    let pollInterval = setInterval(() => {
        let stopPolling = () => {
            clearInterval(pollInterval);
            $tryOnModal.spinner().stop();
        };

        $.ajax({
            url: statusUrl,
            type: 'GET',
            dataType: 'json',
            success: function (data) {
                if (!data.success) {
                    createErrorNotification($(SELECTORS.errorMessage), data.errorMessage);
                    stopPolling();
                    return;
                }

                let generation = (data.replica.userGenerations || [])[0];
                if (!generation) return;

                if (generation.status === 'completed') {
                    createImageSlider(data, true);
                    $(SELECTORS.generateBtnWrapper).addClass(CLASSES.hide);
                    $(SELECTORS.customerImageContainer)
                        .data('token-name', data.tokenName)
                        .data('token-value', data.token)
                        .data('generation-id', generation.id);
                    showFeedback();
                    displayViewer();
                    captureOutfitSignature();
                    stopPolling();
                } else if (generation.status === 'failed') {
                    createErrorNotification($(SELECTORS.errorMessage), generation.error);
                    stopPolling();
                }
            },
            error: function (err) {
                createErrorNotification($(SELECTORS.errorMessage), err.responseJSON.errorMessage);
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                }
                stopPolling();
            }
        });
    }, 3000);
}

function showFeedback() {
    $(SELECTORS.body).trigger('feedback:reset');
    $(SELECTORS.feedbackTab).removeClass(CLASSES.hide);
}

function displayViewer() {
    $(SELECTORS.uploaderTab)
        .addClass(CLASSES.hide);

    $(SELECTORS.viewerTab)
        .removeClass(CLASSES.hide);
}

function createImageSlider(data, userImageOnly) {
    if (data.replica && (data.replica.images || data.replica.userImages)) {
        if (replicaSlider) {
            replicaSlider.destroy();
        }
        $(SELECTORS.viewerTabSlider).html('');
        let imageCount = 0;

        const $newImageBtn = `<button type="button" class="f-button f-button--green js-regenerate-btn generate-new-img">` + window.Resources.TRY_ANOTHER + `</button>`;

        let images = userImageOnly ? data.replica.userImages : data.replica.images;
        imageCount = images.length;
        images.forEach(image => {
            let img = $('<img id="' + image.id + '">');
            img.attr('src', image.image_url);
            // The frame shrink-wraps the image so "Try Another" sits on its corner.
            let imgFrame = $('<div class="try-ai__frame"></div>');
            imgFrame.append(img).append($newImageBtn);
            let imgWrapper = $('<div class="slide"></div>');
            imgWrapper.append(imgFrame);
            $(SELECTORS.viewerTabSlider).append(imgWrapper);
        });

        replicaSlider = tns({
            container: SELECTORS.viewerTabSlider,
            items: 1,
            slideBy: "page",
            loop: false,
            mouseDrag: true,
            speed: 400,
            swipeAngle: false,
            center: false,
            arrowKeys: true,
            prevButton: '.replica-slider-thumbnail-prev',
            nextButton: '.replica-slider-thumbnail-next'
        });

        if (imageCount > 1) {
            hideShowPageButtons(true);
        } else {
            hideShowPageButtons(false);
        }

        // Initialize zoom.
        $(SELECTORS.zoomImage).each(function() {
            $(this).imageZoom({zoom : 200});
        });
    }
}

function hideShowPageButtons(showButton) {
    if (showButton) {
        $(SELECTORS.pageButtons).removeClass(CLASSES.hide);
    } else {
        $(SELECTORS.pageButtons).addClass(CLASSES.hide);
    }
}

/**
 * Markup shown in the preview frame for a selected HEIC/HEIF file.
 *
 * Inline SVG rather than an icon-font class, so it does not depend on an icon
 * stylesheet the project does not ship.
 *
 * @returns {string} placeholder markup for the "other file" preview frame
 */
function buildHeicPlaceholder() {
    var note = (window.Resources && window.Resources.HEIC_PREVIEW_NOTE)
        || 'Preview appears after upload';

    return '<span class="replica-heic-preview">' +
        '<svg class="replica-heic-preview__icon" viewBox="0 0 24 24" width="44" height="44" ' +
            'fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" ' +
            'stroke-linejoin="round" aria-hidden="true" focusable="false">' +
            '<rect x="3" y="4" width="18" height="16" rx="2"></rect>' +
            '<circle cx="8.5" cy="9.5" r="1.5"></circle>' +
            '<path d="M21 15.5 16 10.5 11.5 15 9 12.5 3 18.5"></path>' +
        '</svg>' +
        '<span class="replica-heic-preview__note">' + note + '</span>' +
    '</span>';
}

function initFileUploader() {
    let allowedTypes = ['jpg', 'jpeg', 'png', 'heic', 'heif'];
    let uploadUrl = $(SELECTORS.fileUploaderContainer).data('upload-url');
    $(SELECTORS.fileUploader).fileinput({
        maxFileCount: 1,
        allowedFileTypes: ['image'],
        allowedFileExtensions: allowedTypes,
        allowedPreviewTypes: ['image'],
        disabledPreviewExtensions: ['heic', 'heif'],
        previewFileIconSettings: {
            heic: buildHeicPlaceholder(),
            heif: buildHeicPlaceholder()
        },
        dropZoneTitle: 'Drag & drop 1 photo here',
        dropZoneClickTitle: '<br>(or click to browse)',
        msgPlaceholder: 'Select photo',
        showRotate: false,
        autoOrientImage: true,
        autoOrientImageInitial: true,
        uploadExtraData: {
            'csrf_token': $(SELECTORS.csrfToken).val(),
            'pid': $(SELECTORS.fileUploaderContainer).data('pid')
        },
        uploadUrl: uploadUrl
    }).on('fileuploaded', function(event, data, index, fileId) { // eslint-disable-line
        if (data.response.success) {
            if (data.response.image) {
                $(SELECTORS.customerImageContainer).data('customer-image', data.response.image);
                let newImage = $('<img src="' + data.response.image + '" alt="Customer image" />');
                $(SELECTORS.photoContainer).html(newImage);
                $(SELECTORS.customerImageContainer).removeClass(CLASSES.hide);
                $(SELECTORS.fileUploaderContainer).addClass(CLASSES.hide);
                $(SELECTORS.fileUploaderContainer).data('customer-has-image', true);
            }

            $(SELECTORS.generateBtnWrapper).removeClass(CLASSES.hide);
        }
    }).on('fileuploaderror', function(event, data, msg) { // eslint-disable-line
        $(SELECTORS.generateBtnWrapper).addClass(CLASSES.hide);
        $('.file-error-message').addClass(CLASSES.hide);
        if (data.response.error) {
            msg = data.response.message + ': ' + data.fileId
        } else if (msg.indexOf('csrfError') !== -1) {
            msg = 'Failed to upload image due to token mismatch, reloading the page to retrieve a new token.';
            window.location.reload();
        } else {
            msg = 'File Upload Error: ' + data.fileId
        }
        createErrorNotification($(SELECTORS.errorMessage), msg);
    });

    // WAVE heading_empty / heading_skipped — bootstrap-fileinput injects a global
    // zoom-modal <h6 id="kvFileinputModalLabel"> whose caption stays empty until a
    // file preview is zoomed, leaving an empty heading in the DOM at all times.
    // Seed a default caption so the heading always has an accessible name; the
    // plugin overwrites .kv-zoom-caption with the file name when a preview opens.
    var $zoomCaption = $('#kvFileinputModalLabel .kv-zoom-caption');
    if ($zoomCaption.length && !$zoomCaption.text().trim()) {
        $zoomCaption.text('Image preview');
    }

    // #28 — bootstrap-fileinput leaves hidden close/remove buttons in the DOM
    // with their default tabindex, so keyboard users tab to invisible controls
    // after the Browse button. Scrub them whenever the plugin changes state.
    var refreshUploaderTabOrder = function () {
        $(SELECTORS.fileUploaderContainer)
            .find('.fileinput-remove, .fileinput-cancel, .kv-fileinput-remove, .kv-file-remove, .close')
            .each(function () {
                var $btn = $(this);
                if ($btn.is(':visible')) {
                    $btn.removeAttr('tabindex').removeAttr('aria-hidden');
                } else {
                    $btn.attr('tabindex', '-1').attr('aria-hidden', 'true');
                }
            });
    };

    // WAVE label_missing — bootstrap-fileinput's caption is a readonly
    // <input class="file-caption-name"> that mirrors the chosen file name but
    // has no associated <label>, so WAVE reports a form control with no
    // accessible name. The plugin re-renders the caption on every state change,
    // so (re)apply an aria-label whenever the uploader updates.
    var labelCaptionInput = function () {
        $(SELECTORS.fileUploaderContainer)
            .find('.file-caption-name')
            .attr('aria-label', 'Selected photo');
    };

    $(SELECTORS.fileUploader).on(
        'fileloaded fileclear filereset fileuploaded filebatchpreupload filebatchuploadcomplete',
        function () {
            refreshUploaderTabOrder();
            labelCaptionInput();
        }
    );
    refreshUploaderTabOrder();
    labelCaptionInput();
}

function showBackButton() {
    $(SELECTORS.backBtn).removeClass(CLASSES.hide);
}

const handleTryOnModalCloseButton = () => {
    submitFeedback();

    $(SELECTORS.tryOnModal)
        .addClass(CLASSES.hide)
        .removeClass(CLASSES.flex)
        .attr('aria-hidden', 'true');

    // #20 — restore the rest of the page to AT and return focus to the trigger
    $(BACKGROUND_SELECTOR).removeAttr('aria-hidden');
    $(SELECTORS.body).css('overflow', '');

    if ($lastTryOnTrigger && $lastTryOnTrigger.length) {
        $lastTryOnTrigger.trigger('focus');
        $lastTryOnTrigger = null;
    }
}

function submitFeedback() {
    let hasPendingFeedback = $(SELECTORS.feedbackBtn).hasClass(CLASSES.selected)
        && !$(SELECTORS.feedbackTab).hasClass(CLASSES.hide);

    if (hasPendingFeedback) {
        // Submit pending feedback
        $(SELECTORS.feedbackSubmit).trigger('click');
    }
}

/**
 * Set Cookie Counter for try-on images
 */
const tryonCookieCounter = () => {
    const currentValue = parseInt(cookieHelper.getCookie("replica-counter"), 10) || 0;
    const newValue = currentValue + 1;
    cookieHelper.setCookie("replica-counter", newValue, 30);
    // eslint-disable-next-line no-console
    console.log("Replica CookieCounter:", newValue);
}

function initAccessibility() {
    $(document).on('keydown', function(e) {
        const $tryAiModal = $(SELECTORS.tryOnModal);
        const isModalHidden = $tryAiModal.hasClass(CLASSES.hide);
        if (isModalHidden) {
            return;
        }

        const focusableElementsSelector = 'button:visible, a[href]:visible, input:visible, select:visible, textarea:visible, [tabindex]:not([tabindex="-1"])';
        const focusableElements = $tryAiModal.find(focusableElementsSelector).filter(function() {
            return $(this).closest('.ai-tab').length > 0 ? $(this).closest('.ai-tab').is(':visible') : true ;
        });

        const $firstFocusableElement = focusableElements.first();
        const $lastFocusableElement = focusableElements.last();

        const isTabPressed = e.key === 'Tab' || e.keyCode === 9;
        const isEscapePressed = e.key === 'Escape' || e.keyCode === 27;
        let $activeElement = $(document.activeElement);

        if (isEscapePressed) {
            $(SELECTORS.tryOnModalClose).trigger('click');
            return;
        }

        if (!isTabPressed) {
            return;
        }

        if (e.shiftKey) {
            if ($firstFocusableElement.is($activeElement)) {
                $lastFocusableElement.trigger('focus');
                e.preventDefault();
            }
        } else {
            if ($lastFocusableElement.is($activeElement)) {
                $firstFocusableElement.trigger('focus');
                e.preventDefault();
            }
        }
    });
}

module.exports = {
    init: init
};
